import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BetLimitProviderOption } from '@core/models/bet-limit-group.model';

/**
 * AIO-81599 — step 1 of the bet limit group setup. The form belongs to the parent, which saves
 * all three steps together.
 */
@Component({
  selector: 'kt-bet-limit-group-info-step',
  templateUrl: './group-info-step.component.html',
})
export class GroupInfoStepComponent {
  @Input() form: FormGroup;
  @Input() providers: BetLimitProviderOption[] = [];
  @Input() mode: 'create' | 'edit' | 'default';
  @Input() groupCode: string;

  readonly statuses = [{ id: 1, name: 'Active' }, { id: 0, name: 'Inactive' }];

  invalid(control: string): boolean {
    const c = this.form.get(control);
    return c.invalid && (c.touched || c.dirty);
  }
}
